
/**
 * Normalize a make or model label into an SRP path slug.
 * Exported so the hero component can use the same canonicalization for
 * dropdown option lookup (avoids duplicating the regex chain).
 */
export const toShopSlug = (value: string): string =>
  value
    .replace(/^[\s-]+/, "")
    .toLowerCase()
    .trim()
    .replaceAll("_", "-")
    .replaceAll(/\s+/g, "-")
    .replaceAll(/[^a-z0-9-]/g, "")
    .replaceAll(/-+/g, "-")
    .replaceAll(/^-|-$/g, "");

/**
 * Build the by-owner SRP URL from optional make, model, and ZIP inputs.
 */
export const buildShopUrl = (
  baseUrl: string,
  makeLabel: string,
  modelLabel: string,
  zip: string,
): string => {
  const params = new URLSearchParams();
  const makeSlug = makeLabel ? toShopSlug(makeLabel) : "";
  const modelSlug = modelLabel ? toShopSlug(modelLabel) : "";
  let path = baseUrl;

  if (makeSlug) {
    path += `/${makeSlug}`;
  }

  if (modelSlug) {
    path += `/${modelSlug}`;
  }

  if (makeSlug || modelSlug) {
    path += "/";
  }

  if (zip.length === 5) {
    params.set("zip", zip);
  }

  const queryString = params.toString();
  return path + (queryString ? `?${queryString}` : "");
};
